// extracted by mini-css-extract-plugin
export default {"menu":"CustomSelect_menu__e14Tz","select":"CustomSelect_select__zMyNf","outlined":"CustomSelect_outlined__kv435"};